export const TOGGLE_EMPLOYEE_TABLE = 'TOGGLE_EMPLOYEE_TABLE';